module.exports = __webpack_public_path__ + "static/media/badge_laodong.b293fd67.png";